(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lia-category-links"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('dropdown-menu').then(() => {
    document.querySelectorAll('.lia-shop-dropdown').forEach(menu => {
      const trigger = menu.querySelector('.header__menu-item--top');
      const syncExpanded = () => trigger.setAttribute('aria-expanded', menu.classList.contains('is-active'));
      new MutationObserver(syncExpanded).observe(menu, { attributes: true, attributeFilter: ['class'] });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          trigger.focus();
          menu.close();
        }

      });
      menu.addEventListener('focusout', event => {
        if (!menu.contains(event.relatedTarget)) menu.close();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
